import * as React from "react"
import { css } from "../utils"
import Head from "next/head"
import * as Sentry from "@sentry/browser"
import Document from "next/document"

class ErrorBoundary extends React.Component<{ children: React.ReactNode }> {
  componentDidCatch(error: any) {
    if (window !== undefined && process.env.NODE_ENV === "production") {
      try {
        Sentry?.captureException(error)
      } catch (e) {}

      window.alert("Something went wrong. Please try again later.")
    }
  }

  render() {
    return this.props.children
  }
}

export const Page = ({
  children,
  fluid,
}: {
  children: React.ReactNode
  fluid?: boolean
}) => {
  const gutters = fluid ? undefined : "mx-auto px-4 md:px-16 container"

  return (
    <ErrorBoundary>
      <div className="flex flex-col h-screen bg-gray-900">
        <div className={css(gutters, "flex-grow")}>{children}</div>
      </div>
    </ErrorBoundary>
  )
}
